import React, { useState } from 'react';
// Import the progress bar component
import { Container, Row, Col, Button, Form, Card, InputGroup, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiCopy } from 'react-icons/fi'; // Feather Icons


const Step1 = ({ address }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(address);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <>
            <Form>
                <Row className='justify-content-center align-items-center' style={{ minHeight: '200px' }}>
                    <Col lg={6} >
                        <Card className='text-center'>
                            <Card.Body>
                                <Row className="align-items-center justify-content-center g-2">
                                    <Col xs="auto">
                                        <div
                                            style={{
                                                padding: '6px 6px',
                                            }}
                                        >
                                            D59ZBcaBP8cYvaGyxVzeu5Br8sAaLdYBXURnXNHjoVb
                                        </div>
                                    </Col>
                                    <Col xs="auto">
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip className="custom-tooltip">{copied ? 'Copied!' : 'Copy to clipboard'}</Tooltip>
                                            }
                                        >
                                            <Button variant="outline-secondary" size="sm" onClick={handleCopy} >
                                                <FiCopy />
                                            </Button>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                                {/* <Button>Connect Wallet</Button> */}
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>


            </Form>
        </>
    );
};

export default Step1;
